export var isEmailAddress = function (email) {
    var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return reg.test(email);
};
export var downloadAttachment = function (e, attachment, newWindow) {
    if (newWindow === void 0) { newWindow = false; }
    e.preventDefault();
    e.stopPropagation();
    var url = (attachment.url ? attachment.url : attachment.document.full ? attachment.document.full : attachment.document.url).replace("www.", "").replace("https://variablehub.com", "https://app.variablehub.com").replace("http://variablehub.com", "http://app.variablehub.com");
    if (!newWindow) {
        var link = document.createElement('a');
        link.download = attachment.title;
        link.href = url;
        link.target = "_blank";
        link.click();
    }
    else {
        window.open(url, '_blank');
    }
    return false;
};
